import { render, staticRenderFns } from "./EditEndorsement.vue?vue&type=template&id=647194aa"
import script from "./EditEndorsement.vue?vue&type=script&lang=js"
export * from "./EditEndorsement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports